import axios from "axios";
import { useEffect, useState } from "react";
import Layout from "../Layout.js/Layout.js";
import Loading from "../Loading/Loading.js";
import Error from "../Error/Error.js";

const Main = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [variant, setVariant] = useState("");
    useEffect(() => {
        const searchUrl = window.location.href;

        if (/^https:\/\/url-xhu6.onrender.com\/[^\/]+$/.test(searchUrl)) {
            axios
                .post(`${process.env.REACT_APP_BASE_URL}/short-url`, {
                    shortUrl: searchUrl,
                })
                .then((res) => {
                    if (res.data) {
                        setRedirectUrl(res.data);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setIsError(true);
                        setErrorMessage(
                            "Requested URL not found in the database"
                        );
                        setVariant("info");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    setIsError(true);
                    setIsLoading(false);
                    setVariant("warning");
                    setErrorMessage(
                        "please try after sometime. server maybe down"
                    );
                });
        } else if (/^https:\/\/url-xhu6.onrender.com(\/)?$/.test(searchUrl)) {
            setIsLoading(false);
        } else {
            setIsLoading(false);
            setIsError(true);
            setErrorMessage("Requested URL not found in the database");
            setVariant("info");
        }
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    if (isError) {
        return <Error message={errorMessage} variant={variant} />;
    }

    if (redirectUrl) {
        window.location.href = redirectUrl;
        return null;
    }
    return (
        <>
            <Layout />
        </>
    );
};

export default Main;
